<template>
  <div class="pb-2">
    <v-popover :offset="`1`"
      v-for="(res, index) in board.results" :key="index"
      :id="`${$options.filters.slugify(board.key)}-${index}`"
      :container="`#${$options.filters.slugify(board.key)}-${index}`"
      :boundariesElement="`viewport`"
      :trigger="`${res.data.slug_values ? 'hover' : 'none'}`"
      :popoverClass="`landscape-card-tooltip`"
      :popoverWrapperClass="`hide-for-touch d-none d-md-block`"
      :popoverArrowClass="['tooltip-arrow']"
      :placement="`left`"
      :disposeTimeout="5000"
      @apply-show="triggerTooltipLoading(index)"
    >
      <component
        :is="res.data.slug_values ? 'router-link' : 'div'"
        :to="{
          name: `${board.item_type}.show`,
          params: { id: res.data && res.data.slug_values && res.data.slug_values[0] || '' }
        }"
        class="d-block mb-1 t-primary landscape-item bd-radius p-1 position-relative"
        :title="res.data.full_name || res.data.name"
      >
        <div class="d-flex align-items-baseline landscape-card-content">
          <span class="t-overflow t-600">{{ res.data.full_name || res.data.name }}</span>
          <template v-if="res.data.ranking_h_index">
            <span class="t-secondary t-md mx-1 t-800"><i>h</i></span><span class="t-700 t-primary">{{ res.data.ranking_h_index }}</span>
          </template>
          <i class="fa fa-trophy ml-1 t-yellow" v-if="res.data.scientific_awards_count" />
          <div v-if="res.data.count_type" class="text-nowrap ml-2 landscape-card-content flex-grow-1 text-right">
            <span class="t-500 t-primary">{{ res.data.count | formatNumberShort(1) }}</span>
            <i class="fa ml-1 t-secondary" :class="icons[res.data.count_type]" />
          </div>
        </div>
        <template v-if="!isEmpty(res.data.organisations)">
          <div class="d-flex align-items-baseline t-compact landscape-card-content">
            <span>
              <flag :title="renderCountryFlagTooltip(res.data.organisations[0].country)"
                v-if="res.data.organisations[0].country && res.data.organisations[0].country.alpha_2"
                :iso="res.data.organisations[0].country.alpha_2 | lowercase"
                :squared="false"
                class="bd-radius mr-1 t-xs"
              />
            </span>
            <span class="t-overflow t-sm t-primary" :title="res.data.organisations[0].name">
              {{ res.data.organisations[0].name }}
            </span>
          </div>
        </template>
        <template v-else-if="!isEmpty(res.data.country)">
          <div class="d-flex align-items-baseline t-compact landscape-card-content">
            <span>
              <flag :title="renderCountryFlagTooltip(res.data.country)"
                v-if="res.data.country && res.data.country.alpha_2"
                :iso="res.data.country.alpha_2 | lowercase"
                :squared="false"
                class="bd-radius mr-1 t-xs"
              />
            </span>
            <span class="t-overflow t-sm">
              {{ res.data.foundation_date | formatDate('YYYY') }}
            </span>
          </div>
        </template>
        <div v-if="partialBGMax" class="landscape-card-count-bg" :style="`width: ${(res.data.count / partialBGMax) * 100}%;`" />
      </component>
      <template #popover>
        <research-group-tooltip
          v-if="res.data.slug_values"
          :data="res.data"
          :index="'research_groups'"
          :highlights="{}"
          :highlightsLoading="false"
          :matches="[]"
          :inViewportActive="activeTooltips.indexOf(index) > -1"
        />
      </template>
    </v-popover>
    <div class="d-flex justify-content-end position-absolute" style="bottom: 16px; right: 20px;"
      v-if="!board.isLoading && board.results.length > 0 && board.url"
    >
      <router-link class="d-flex align-items-center" :to="board.url">
        <i class="fa fa-th-large t-secondary mr-1" />
        <span class="t-600 t-sm">Show all</span>
      </router-link>
    </div>
    <div v-if="!board.isLoading && board.results.length === 0" class="t-secondary t-600">
      No Research Groups found
    </div>
  </div>
</template>

<script>
import ResearchGroupTooltip from '@/components/search/landscape/ResearchGroupTooltip'
import listHelpers from '@/components/search/landscape/listHelpers'

export default {
  name: 'researchGroupList',
  mixins: [listHelpers],
  components: {
    ResearchGroupTooltip
  },
  props: {
    board: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      activeTooltips: []
    }
  },
  methods: {
    triggerTooltipLoading (i) {
      // Trick to manually trigger inViewport to fetch graph data
      if (this.activeTooltips.indexOf(i) !== -1) return
      this.activeTooltips.push(i)
    }
  }
}
</script>
